export const DATAKEY_PROFILE_NAME = 'profileName';
export const LABEL_PROFILE_NAME = 'Name';
export const ABBREVIATION_PROFILE_NAME = 'name';
export const DATAKEY_CREATED_BY = 'createdBy';
export const LABEL_CREATED_BY = 'Created By';
export const ABBREVIATION_CREATED_BY = 'createdby';
export const DATAKEY_CREATED_DATE = 'createdDate';
export const LABEL_CREATED_DATE = 'Created Date';
export const ABBREVIATION_CREATED_DATE = 'createddate';
export const DATAKEY_UPDATED_BY = 'updatedBy';
export const LABEL_UPDATED_BY = 'Updated By';
export const ABBREVIATION_UPDATED_BY = 'updatedby';
export const DATAKEY_UPDATED_DATE = 'updatedDate';
export const LABEL_UPDATED_DATE = 'Updated Date';
export const ABBREVIATION_UPDATED_DATE = 'updateddate';
export const DATAKEY_PROFILE_DESCRIPTION = 'profileDescription';
export const LABEL_PROFILE_DESCRIPTION = 'Description';
export const ABBREVIATION_PROFILE_DESCRIPTION = 'description';
export const EMPTY_STRING = '';
export const ESTIMATE_PROFILE_LIST_MAKE_DEFAULT = 'Make Default';
export const ESTIMATE_PROFILE_LIST_DUPLICATE_PROFILE = 'Duplicate profile';
export const ESTIMATE_PROFILE_LIST_DELETE_PROFILE = 'Delete Profile';
export const ESTIMATE_PROFILE_LIST_DEFAULT_SUFFIX = '(Default)';
export const ESTIMATE_PROFILE_LIST_ESTIMATE_PROFILES = 'Estimate Profiles';
export const ESTIMATE_PROFILE_LIST_DONE_LABEL = 'Done';
export const ESTIMATE_PROFILE_LIST_DELETED_PROFILES = 'Deleted Profiles';
export const ESTIMATE_PROFILE_LIST_RESTORE = 'restore';
export const ESTIMATE_PROFILE_LIST_SUCCESS = 'success';
export const ESTIMATE_PROFILE_LIST_LOADING = 'loading';
export const ESTIMATE_PROFILE_LIST_FAILURE = 'failure';
export const ESTIMATE_PROFILE_LIST_RESTORED = 'Restored';
export const ESTIMATE_PROFILE_LIST_RESTORE_PROFILE = 'Restore Profile';
export const ESTIMATE_PROFILE_LIST_ASK_CONFIRMATION = 'ask_confirmation';
export const ESTIMATE_PROFILE_RESTORE_BUTTON_LABEL = 'Restore';
export const ESTIMATE_PROFILE_CANCEL_BUTTON_LABEL = 'Cancel';
export const ESTIMATE_PROFILE_RESTORE_WARNING_MESSAGE = 'Restoring this profile will make it available to all assigned users.';
export const ESTIMATE_PROFILE_LIST_DELETED_PROFILES_MODAL_HEADER = [
    {
        dataKey: DATAKEY_PROFILE_NAME,
        label: LABEL_PROFILE_NAME,
        abbreviation: ABBREVIATION_PROFILE_NAME,
        cellPadding: 0,
        shouldShowEllipsis: true,
        disableSort: true
    },
    {
        dataKey: DATAKEY_CREATED_BY,
        label: LABEL_CREATED_BY,
        abbreviation: ABBREVIATION_CREATED_BY,
        cellPadding: 0,
        shouldShowEllipsis: true,
        disableSort: true
    },
    {
        dataKey: DATAKEY_CREATED_DATE,
        label: LABEL_CREATED_DATE,
        abbreviation: ABBREVIATION_CREATED_DATE,
        shouldShowEllipsis: true,
        disableSort: true
    },
    {
        dataKey: DATAKEY_UPDATED_BY,
        label: LABEL_UPDATED_BY,
        abbreviation: ABBREVIATION_UPDATED_BY,
        shouldShowEllipsis: true,
        disableSort: true
    },
    {
        dataKey: DATAKEY_UPDATED_DATE,
        label: LABEL_UPDATED_DATE,
        abbreviation: ABBREVIATION_UPDATED_DATE,
        cellPadding: 0,
        shouldShowEllipsis: true,
        disableSort: true
    },
    {
        dataKey: DATAKEY_PROFILE_DESCRIPTION,
        label: LABEL_PROFILE_DESCRIPTION,
        abbreviation: ABBREVIATION_PROFILE_DESCRIPTION,
        disableSort: true,
        shouldShowEllipsis: true
    },
    {
        dataKey: ESTIMATE_PROFILE_LIST_RESTORE,
        label: EMPTY_STRING,
        cellPadding: 0,
        disableSort: true,
        shouldShowEllipsis: true
    }
];
//# sourceMappingURL=EstimateProfileListDeletedProfilesModalConstants.js.map